import React, { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Form, FloatingLabel, Image, Card, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
// import { BedTypeServices } from "../../services/BedType";
import LoadingModal from "../components/LoadingModal";
import { TalukServices } from "../../services/Taluk";
import { AshaBlockServices } from "../../services/AshaBlocks";
import { PHCServices } from "../../services/Phcs";
import { AshaServices } from "../../services/AshaService";
import { AuthService } from "../../services/AuthService";
import AlertModal from "../../components/AlertModal";

function EditAshaModal({ show, onHide, asha }) {
 const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [ashas, setAshas] = useState({
    name: "",
    preDefinedAshaId: "",
    populationAlloted: "",
    noOfHousesAlloted: "",
    mobileNo: "",
    village: "",
    phco: "",
    hio: "",
    cho: "",
    ashaBlockId: undefined,
  });
  const [taluk, setTaluk] = useState(null);
  const [phc, setPhc] = useState(null);
  const [taluks, setTaluks] = useState([]);
  const [phcs, setPHCs] = useState([]);
  const [ablocks, setAblocks] = useState([]);
  const [error, setError] = useState({});

  const user = JSON.parse(localStorage.getItem("user"));
  const { isSuperAdmin, isTaluk, isPhc, isAshaBlock } = useMemo(() => ({
    isSuperAdmin: user?.roleDetails?.role === "Super Admins",
    isTaluk: user?.roleDetails?.role === "Taluk",
    isPhc: user?.roleDetails?.role === "PHC",
    isAshaBlock: user?.roleDetails?.role === "Asha Block",
  }), [user]);

  useEffect(() => {
    if (isSuperAdmin) {
      getTaluks();
      getPhcs();
      getAblocks();
    } else if (isTaluk) {
      getPhcs(user?.talukDetails?.id);
      getAblocks(user?.talukDetails?.id);
    } else if (isPhc) {
      getAblocks(null, user?.phcDetails?.id);
    }

    setTaluk(asha.ashaBlockDetails.phcDetails.talukDetails.id);
    setPhc(asha.ashaBlockDetails.phcDetails.id);
    setAshas({
      id: asha.id,
      name: asha.name,
      preDefinedAshaId: asha.preDefinedAshaId,
      populationAlloted: asha.populationAlloted,
      noOfHousesAlloted: asha.noOfHousesAlloted || "",
      mobileNo: asha.mobileNo,
      village: asha.village,
      phco: asha.phco,
      hio: asha.hio,
      cho: asha.cho,
      ashaBlockId: asha.ashaBlockDetails.id,
    });
  }, [asha]);

  const getTaluks = async () => {
    try {
      const res = await TalukServices.getAllTaluks();
      if (Array.isArray(res)) {
        setTaluks(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setTaluks(values);
        } else {
          setTaluks([]);
        }
      } else {
        setTaluks([]);
      }
    } catch (error) {
      console.error("Failed to load Taluks", error);
      setTaluks([]);
    }
  };

  const getPhcs = async (talukId = null) => {
    try {
      const res = talukId
        ? await PHCServices.gePhcsByTalukId(talukId)
        : await PHCServices.getAllPhcs();
      if (Array.isArray(res)) {
        setPHCs(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setPHCs(values);
        } else {
          setPHCs([]);
        }
      } else {
        setPHCs([]);
      }
    } catch (error) {
      console.error("Failed to load PHCs", error);
      setPHCs([]);
    }
  };

  const getAblocks = async (talukId = null, phcId = null) => {
    try {
      let res;
      if (phcId) {
        res = await AshaBlockServices.geAshaBlockByPhcId(phcId);
      } else if (talukId) {
        res = await AshaBlockServices.getAshaBlockByTalukId(talukId);
      } else {
        res = await AshaBlockServices.getAllAshaBlocks();
      }
      if (Array.isArray(res)) {
        setAblocks(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setAblocks(values);
        } else {
          setAblocks([]);
        }
      } else {
        setAblocks([]);
      }
    } catch (error) {
      console.error("Failed to load AshaBlocks", error);
      setAblocks([]);
    }
  };

  const handleChange = (field, value) => {
    setAshas({ ...ashas, [field]: value });
  };

  const handleValidation = () => {
    let valid = true;
    let temp = {};
    ["name", "preDefinedAshaId", "populationAlloted", "mobileNo", "village", "ashaBlockId"].forEach((key) => {
      if (!ashas[key]) {
        temp[key] = `${key} is required`;
        valid = false;
      }
    });
    if (ashas.mobileNo && !/^\d{10}$/.test(ashas.mobileNo)) {
      temp.mobileNo = "Mobile no must be 10 digits";
      valid = false;
    }
    setError(temp);
    return valid;
  };

  const handleSubmit = async () => {
    if (!handleValidation()) return;
    setLoading(true);
    try {
      const res = await AshaServices.updateAshas(ashas);
      if (res.status === 200) {
        setAlertMessage("Asha updated successfully");
        setShowAlert(true);
      } else {
        setAlertMessage("Error updating Asha");
        setShowAlert(true);
      }
    } catch (error) {
      onHide(); // Close the edit modal first
      setAlertMessage(error.message);
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Asha</Modal.Title>
      </Modal.Header>
      <Container className="mt-4">
        <div className="input-modal-spacing">
          <Row>
            <Col>
              <FloatingLabel
                controlId="editAshaId"
                label="Asha Id*"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Asha Id*"
                  value={ashas.preDefinedAshaId}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      preDefinedAshaId: e.target.value,
                    })
                  }
                  isInvalid={!!error.preDefinedAshaId}
                />
                <p className="required-field-meassage">
                  {error.preDefinedAshaId}
                </p>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="editName"
                label="Name*"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Name*"
                  value={ashas.name}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      name: e.target.value,
                    })
                  }
                  isInvalid={!!error.name}
                />
                <p className="required-field-meassage">{error.name}</p>
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <FloatingLabel
                controlId="editpopulationAllotted"
                label="Population Allotted*"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Population Allotted*"
                  value={ashas.populationAlloted}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      populationAlloted: e.target.value,
                    })
                  }
                  isInvalid={!!error.populationAlloted}
                />
                <p className="required-field-meassage">
                  {error.populationAlloted}
                </p>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="editNoOfHousesAlloted"
                label="No.of houses alloted"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="No.of houses alloted"
                  value={ashas.noOfHousesAlloted}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      noOfHousesAlloted: e.target.value,
                    })
                  }
                  isInvalid={!!error.noOfHousesAlloted}
                />
                <p className="required-field-meassage">{error.noOfHousesAlloted}</p>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="editVillage"
                label="Village*"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Village*"
                  value={ashas.village}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      village: e.target.value,
                    })
                  }
                  isInvalid={!!error.village}
                />
                <p className="required-field-meassage">{error.village}</p>
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <FloatingLabel
                controlId="editMobNo"
                label="Mob no*"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Mob no*"
                  value={ashas.mobileNo}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      mobileNo: e.target.value,
                    })
                  }
                  isInvalid={!!error.mobileNo}
                />
                <p className="required-field-meassage">{error.mobileNo}</p>
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              {isSuperAdmin ? (
                <FloatingLabel controlId="editTaluk" label="Taluk*">
                  <Form.Select
                    aria-label="Taluk*"
                    value={taluk}
                    onChange={(e) => {
                      getPhcs(e.target.value);
                      setTaluk(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {taluks.map((t) => (
                      <option key={t.id} value={t.id}>{t.taluk}</option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              ) : (
                <FloatingLabel controlId="editTaluk" label="Taluk*">
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue={asha.ashaBlockDetails.phcDetails.talukDetails.taluk}
                  />
                </FloatingLabel>
              )}
            </Col>
            <Col>
              {isSuperAdmin || isTaluk ? (
                <FloatingLabel controlId="editPhc" label="PHC*">
                  <Form.Select
                    aria-label="PHC*"
                    value={phc}
                    onChange={(e) => {
                      setPhc(e.target.value);
                      getAblocks(null, e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {phcs.map((p) => (
                      <option key={p.id} value={p.id}>{p.phc}</option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              ) : (
                <FloatingLabel controlId="editPhc" label="PHC*">
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue={asha.ashaBlockDetails.phcDetails.phc}
                  />
                </FloatingLabel>
              )}
            </Col>

            <Col>
              {isSuperAdmin || isTaluk || isPhc ? (
                <FloatingLabel controlId="editAshaBlock" label="Asha Block*">
                  <Form.Select
                    aria-label="Asha Block*"
                    value={ashas.ashaBlockId}
                    onChange={(e) => handleChange("ashaBlockId", e.target.value)}
                    isInvalid={!!error.ashaBlockId}
                  >
                    <option value="">Select</option>
                    {ablocks.map((a) => (
                      <option key={a.id} value={a.id}>{a.ashaBlock}</option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              ) : (
                <FloatingLabel controlId="editAshaBlock" label="Asha Block*">
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue={asha.ashaBlockDetails.ashaBlock}
                  />
                </FloatingLabel>
              )}
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <FloatingLabel
                controlId="editPhco"
                label="PHCO"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="PHCO"
                  value={ashas.phco}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      phco: e.target.value,
                    })
                  }
                  isInvalid={!!error.phco}
                />
                {/* <p className="required-field-meassage">{error.phco}</p> */}
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="editHio"
                label="HIO"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="HIO"
                  value={ashas.hio}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      hio: e.target.value,
                    })
                  }
                  isInvalid={!!error.hio}
                />
                {/* <p className="required-field-meassage">{error.function}</p> */}
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel
                controlId="editCho"
                label="CHO"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="CHO"
                  value={ashas.cho}
                  onChange={(e) =>
                    setAshas({
                      ...ashas,
                      cho: e.target.value,
                    })
                  }
                  isInvalid={!!error.cho}
                />
                {/* <p className="required-field-meassage">{error.cho}</p> */}
              </FloatingLabel>
            </Col>
          </Row>
        </div>
        <Row className="mt-4">
          <Col>
            <div className="d-flex justify-content-end gap-2">
              <Button onClick={handleSubmit} variant="success">Save</Button>
              <Button onClick={onHide} variant="danger">Cancel</Button>
            </div>
          </Col>
        </Row>
      </Container>
      {loading && <LoadingModal />}
    </Modal>
    <AlertModal
      show={showAlert}
      onHide={() => {
        setShowAlert(false);
        if (alertMessage === "Asha updated successfully") {
          onHide(); // now close the modal
          navigate("/asha");
        }
      }}
      message={alertMessage}
    />
    </>
  );
}

function EditAsha(props) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        style={{ color: '#05275a' }}
        size="lg"
        onClick={() => setModalShow(true)}
      />
      {modalShow && (
        <EditAshaModal
          show={modalShow}
          onClick={props.onHide}
          onHide={() => {
            setModalShow(false);
            props.onClose();
          }}
          asha={props.asha}
        />
      )}
    </>
  );
}

export default EditAsha;
